module.exports = __webpack_public_path__ + "img/error.16d3d943.svg";